export default {

    getComponentType(state){
        return state.componentType
    },

    getProductId(state){
        return state.productId
    },

    getJourneyId(state){
        return state.journeyId
    },

    getDayId(state){
        return state.dayId
    },
}


// WEBPACK FOOTER //
// ./src/vuex/toursVip/getter.js